import React from 'react';
import Button from '@material-ui/core/Button';
import {CustomButton} from './style.js';

export function ButtonComp(props) {
    const { label,handleClick } = props;
    return (
        <>
            <CustomButton>
                <Button onClick={handleClick} variant="contained">
                    {label}
                </Button>
            </CustomButton>
        </>
    )
}
export default ButtonComp;